import { type } from 'arktype';

/**
 * Payload for the plan-version wipe workflow (AC8a in
 * docs/specs/auto-fill-solver-correctness.md). Mirrors the instance-side
 * `clearAssignmentsInputSchema` shape (CAS token on `updatedAt`) but the
 * scope is the entire version — no date range, no filter.
 */
export const clearPlanVersionAssignmentsInputSchema = type({
  baseVersionUpdatedAt: type('string').configure({
    description:
      "Optimistic-concurrency token. Must match the plan version's current `updatedAt` ISO timestamp; the server rejects the request with 409 when stale.",
    examples: ['2026-07-23T08:00:00.000Z'],
  }),
}).configure({ description: 'Payload for clearing every assignment on a plan version.' });

export type ClearPlanVersionAssignmentsInput = typeof clearPlanVersionAssignmentsInputSchema.t;

export const clearPlanVersionAssignmentsResponseSchema = type({
  updatedAt: type('string').configure({
    description: 'New `updatedAt` of the plan version after the wipe — use as the next CAS token.',
    examples: ['2026-07-23T08:01:00.000Z'],
  }),
}).configure({ description: 'Response of the clear-assignments endpoint on a plan version.' });

export type ClearPlanVersionAssignmentsResponse = typeof clearPlanVersionAssignmentsResponseSchema.t;
